module.exports = __webpack_public_path__ + "img/user-16.e8c9d78e.svg";